/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable global-require */
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { RouterV2Enum } from '@/router/router-names';
import FinanceBusiness from '@/mixins/finance-business';
import { namespace } from 'vuex-class';
import '@/views_v2/home/store';
import { HomeThemeEnums } from '@/shared/utils/pageTheme';

const style = require('./index.module.scss') as Dictionary;

const HomeStore = namespace('home');
@Component
export default class AboutPanel extends Mixins(
  FinanceBusiness,
) {
  @Prop()
  private currentPage!: string

  @HomeStore.Action getUserAutarkyState!: () => Promise<boolean>;

  @HomeStore.State homeThemeType!: HomeThemeEnums;


  // 如何完成授信
  private onCreadit() {
    this.$ubtPageButton('finance_grant_credit', 'label', this.currentPage);
    this.$router.push({
      path: RouterV2Enum.usingGuid,
      query: {
        index: '0',
      },
    });
  }

  // 如何提现
  private onWidthraw() {
    this.$ubtPageButton('finance_widthraw', 'label', this.currentPage);
    this.$router.push({
      path: RouterV2Enum.usingGuid,
      query: {
        index: '1',
      },
    });
  }

  // 如何还款
  private onPayOff() {
    this.$ubtPageButton('finance_pay_money', 'label', this.currentPage);
    this.$router.push({
      path: RouterV2Enum.usingGuid,
      query: {
        index: '2',
      },
    });
  }

  private async mounted() {
    await this.getUserAutarkyState();
  }

  private render() {
    if (this.isAutarkySucceed()) {
      return null;
    }
    return (
      <div class={[style.aboutPart]}>
        <div class={style.aboutTop}>
          <div class={style.textPart}>
            <div>认识臻有钱</div>
            <div>合规专业 精准匹配 权威合作</div>
          </div>
          <div class={style.picPart} onClick={this.jumpAboutUs.bind(this)}>
            <div class={style.centerIcom}>
              <span>了解我们</span>
              <span></span>
            </div>
          </div>
        </div>
        <div class={style.aboutBottomNormal}>
          <div class={style.arrow} onClick={this.onCreadit.bind(this)}>
            <span class={style.beforeArrow}></span>
            <span class={style.listText}>授信指南</span>
            <span class={style.afterArrow}></span>
          </div>
          <div class={style.arrow} onClick={this.onWidthraw.bind(this)}>
            <span class={style.beforeArrow}></span>
            <span class={style.listText}>如何提现</span>
            <span class={style.afterArrow}></span>
          </div>
          <div class={style.arrow} onClick={this.onPayOff.bind(this)}>
            <span class={style.beforeArrow}></span>
            <span class={style.listText}>如何还款</span>
            <span class={style.afterArrow}></span>
          </div>
        </div>
      </div>
    );
  }

  private jumpAboutUs() {
    this.$ubtPageButton('finance_aboutUs', 'label', this.currentPage);

    this.$router.push({
      path: RouterV2Enum.aboutUs,
    });
  }
}
